import React, { useState } from 'react';
import GalleryGrid from '../../components/GalleryGrid/GalleryGrid';
import GalleryItem from '../../components/GalleryItem/GalleryItem';
import GallerySideNav from '../../components/GallerySideNav/GallerySideNav';
import Lightbox from '../../components/Lightbox/Lightbox';
import styles from './GalleryPage.module.css';
import { albums } from '../../data/galleryData';

const GalleryPage = () => {
  const [selectedAlbum, setSelectedAlbum] = useState('All');
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const handleImageClick = (images, index) => {
    setLightboxImages(images);
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxImages([]);
  };

  return (
    <main className={styles.galleryPageLayout}>
      <GallerySideNav
        albums={albums}
        selectedAlbum={selectedAlbum}
        onSelectAlbum={setSelectedAlbum}
        isNavCollapsed={isNavCollapsed}
        onToggleNav={() => setIsNavCollapsed(!isNavCollapsed)}
      />
      <div className={styles.galleryContent}>
        <section id="gallery" className={styles.contentSection}>
          <h1 className={`${styles.pageTitle} page-main-title`}>Gallery</h1>

          {selectedAlbum === 'All' ? (
            // If "All" is selected, map through all albums and render each one
            albums.map((album, index) => (
              <div key={index} className={styles.albumSection}>
                <h2 className={styles.albumTitle}>{album.title}</h2>
                <GalleryGrid>
                  {album.images.map((src, imgIndex) => (
                    <GalleryItem
                      key={imgIndex}
                      src={src}
                      onClick={() => handleImageClick(album.images, imgIndex)}
                    />
                  ))}
                </GalleryGrid>
              </div>
            ))
          ) : (
            // If a specific album is selected, find it and render it
            (() => {
              const album = albums.find(a => a.title === selectedAlbum);
              return album ? (
                <div className={styles.albumSection}>
                  <h2 className={styles.albumTitle}>{album.title}</h2>
                  <GalleryGrid>
                    {album.images.map((src, imgIndex) => (
                      <GalleryItem
                        key={imgIndex}
                        src={src}
                        onClick={() => handleImageClick(album.images, imgIndex)}
                      />
                    ))}
                  </GalleryGrid>
                </div>
              ) : null;
            })()
          )}
        </section>
      </div>

      {/* Lightbox Component */}
      {lightboxImages.length > 0 && (
        <Lightbox
          images={lightboxImages}
          initialIndex={lightboxIndex}
          onClose={closeLightbox}
        />
      )}
    </main>
  );
};

export default GalleryPage;